// 价格输入只去零和校验，不使用会四舍五入的展示格式化方法。
export const PRICE_PRECISION_MESSAGE = "最多4位小数";
const DECIMAL = /^\d+(?:\.\d+)?$/;

export function normalizePriceInput(value) {
  if (value === null || value === undefined) return "";
  const text = String(value).trim();
  if (!DECIMAL.test(text)) return text;
  return text.includes(".")
    ? text.replace(/0+$/, "").replace(/\.$/, "")
    : text;
}

export function validatePriceInput(value) {
  const normalized = normalizePriceInput(value);
  let code = null;
  if (!normalized) code = "empty";
  else if (!DECIMAL.test(normalized)) code = "invalid_format";
  else if ((normalized.split(".")[1] || "").length > 4) code = "too_many_decimals";
  return { valid: code === null, code, value: normalized };
}

export function getPriceInputError(value, { optional = false, negativeMessage = "请填写大于或等于0的值" } = {}) {
  const result = validatePriceInput(value);
  if (result.valid || (optional && result.code === "empty")) return "";
  if (result.code === "empty") return "请填写价格或金额";
  if (/^-\d+(?:\.\d+)?$/.test(result.value)) return negativeMessage;
  return result.code === "too_many_decimals"
    ? PRICE_PRECISION_MESSAGE
    : "请填写有效的数字";
}

// 显式列出用户可编辑的价格字段，避免按名称猜测并误改重量、比例或银行信息。
export function checkPriceFields(fields, notify) {
  for (const { target, key, optional = true, focus, negativeMessage } of fields) {
    const value = target[key];
    const error = getPriceInputError(value, { optional, negativeMessage });
    const normalized = normalizePriceInput(value);
    // 保持接口和表单原有数字/字符串类型；字符串不经过 Number，避免大数精度损失。
    if (typeof value === "string") target[key] = normalized;
    if (error) {
      if (notify) notify(error);
      if (focus) focus();
      return false;
    }
  }
  return true;
}
